/**
 * Favourites Module
 * Encapsulates all functionality for the Favourites page.
 */
const favouritesModule = (function () {

    // Module-level private variables
    let favouritesViewer = null;
    let SHOPPING_CART_EMPTY, SHOPPING_CART_FULL, REMOVE_ICON;
    let _originalGoBack = null;


    /**
     * The HTML template for the Favourites page.
     * This will be loaded into the content area when the module is activated.
     */
    const _templateHTML = `
   
    <!-- BEGIN CONTAINER -->
    <div id="favouritesWrapper" class="page-container">
        <!-- BEGIN SIDEBAR -->
        <div class="page-sidebar-wrapper">
            <div id="mySidebar" class="page-sidebar navbar-collapse collapse">

                <ul class="page-sidebar-menu page-sidebar-menu-hover-submenu "
                    data-keep-expanded="false" data-auto-scroll="true"
                    data-slide-speed="200">

                    <li class="customcolor">
                        <a  href="javascript:;" data-module-action="loadIndex">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon home-icon" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="homeButton" data-translation-default="Home">Home</span>
                            </div>
                        </a>
                    </li>

                    <li class=" customcolor">
                        <a href="assetLibrary.html">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="Library" class="side-bar-icon library-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="libraryButton" data-translation-default="Library">Library</span>
                            </div>
                        </a>
                    </li>

                    <li id="favouritesSideMenuIcon" class="active open customcolor">
                        <a href="javascript:;" data-module-action="loadFavourites">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon favourites-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="favouritesButton" data-translation-default="Favourites">Favourites</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>

                    <li id="inboxSideMenuIcon" style="display:none" class="customcolor">
                        <a href="inbox.html">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon inbox-icon" style="width: 36px;">
                                        <span class="badge badge-warning" id="salestoolkit-inbox-badge"></span>
                                    </div>
                                </div>
                                <span class="title" data-translation-key="inboxButton"
                                    data-translation-default="Inbox">Inbox</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>

                    <li id="cartSideMenuIcon" class="customcolor">
                        <a  href="javascript:;" data-module-action="loadCart">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon cart-icon" style="width: 36px;">
                                        <span class="badge badge-warning" id="salestoolkit-cart-badge"></span>
                                    </div>
                                </div>
                                <span class="title" data-translation-key="cartButton" data-translation-default="Cart">Cart</span>
                            </div>
                        </a>
                    </li>

                    <li id="meetingsSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showMeetingsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon meetings-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="meetingsButton" data-translation-default="Meetings">Meetings</span>
                            </div>
                        </a>
                    </li>

                    <li id="contactsSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showContactsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon contacts-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="contactsButton" data-translation-default="Contacts">Contacts</span>
                            </div>
                        </a>
                    </li>

                    <li class="demoComparatorSideMenu customcolor">
                        <a id="comparator-side-menu" href="javascript:;" onclick="loadPlugin('debugComparator', this, false)">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon plugin-icon" src="img/default/comparator_menu.svg" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="pluginButton" data-translation-default="Debug Comparator">Debug Comparator</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>

                    <li id="adminSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showAdminScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon admin-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="adminButton"
                                    data-translation-default="Admin">Admin</span>
                            </div>
                        </a>
                    </li>
                    
                  <li id="faqsSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showFaqsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon faqs-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="faqButton"
                                    data-translation-default="FAQs">FAQs</span>
                            </div>
                        </a>
                    </li>
                    <li id="newsSideMenuIcon" class="customcolor">
                        <a onclick="loadNews(this); return false;">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon news-icon" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="newsButton" data-translation-default="News">News</span>
                            </div>
                        </a>
                    </li>


                </ul>
                <!-- END SIDEBAR MENU -->
                <script src="js/sidemenufix.js?version=b00000"></script>
            </div>
        </div>
        <!-- END SIDEBAR -->
        <!-- BEGIN CONTENT -->
        <div class="page-content-wrapper">
            <div id="main-div-center" class="page-content">
                <!-- BEGIN SAMPLE PORTLET CONFIGURATION MODAL FORM-->
                <div class="modal fade" id="basic" tabindex="-1" role="basic"
                     aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal"
                                        aria-hidden="true"></button>
                                <h4 class="modal-title">
                                    <i class="icon-envelope font-blue"></i> Send Assets
                                </h4>

                            </div>
                            <div class="modal-body">
                                <span class="badge badge-roundless badge-success">Consent</span>
                                By completing the form below, I consent to all selected
                                electronic documents to be sent to the email address(es) I have
                                supplied.
                            </div>
                            <div class="portlet-body form">
                                <form role="form">
                                    <div class="form-body">

                                        <label class="sendpadding">E-mail Address</label>

                                        <div class="form-group formgrouppadding">
                                            <div class="input-group sendpadding">
                                                <div class="col-md-11 input-group margin-top-5">
                                                    <span class="input-group-addon">
                                                        <i class="fa fa-envelope"></i>
                                                    </span> <input type="email" class="form-control"
                                                                   placeholder="example@example.com">
                                                </div>
                                                <span class="input-group-btn">
                                                    <a href="javascript:;"
                                                       class="btn btn-circle btn-icon-only btn-default">
                                                        <i class="fa fa-plus"></i>
                                                    </a>

                                                </span>
                                            </div>

                                        </div>

                                        <div class="checkbox-list tccheck accepttc">
                                            <label class="pull-left">
                                                <div class="checker">
                                                    <span class="">
                                                        <input type="checkbox">
                                                    </span>
                                                </div> Accept Terms & Conditions
                                            </label>


                                            <button type="button" class="btn default" data-dismiss="modal">Cancel</button>
                                            <button id="notific8Test" type="button" class="btn blue" data-dismiss="modal">Send</button>
                                        </div>

                                    </div>

                                </form>
                            </div>
                            <div class="modal-footer">
                                <p class="termsandconditions">
                                    Authorisation for the use of
                                    e-mail to send out all selected documents. The Atheneum system
                                    will distribute the selected materials electronically via
                                    e-mail. This requires that you supply your e-mail address. The
                                    Atheneum System (powered by DelegateBag) will use your e-mail to
                                    send the documents which you have requested during this sales
                                    call / meeting and for reporting and administrative purposes.
                                    They will not be ditributed to 3rd parties for markeing or
                                    sales purposes. Additional information on our data privacy
                                    practices and our full terms and conditions are available on
                                    request.
                                </p>
                            </div>
                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                </div>
               
                <div class="row">
                    <div class="col-md-12">
                        <div class="sidePadding10 portlet light">
                            <div class="portlet-title">
                                <div class="caption">
                                    <!-- <i class="fa fa-heart font-blue"></i> -->
                                    <strong><span data-translation-key="favouritedAssets" data-translation-default="Favourited Assets">Favourited Assets</span></strong>
                                </div>
                                <div class="actions" style="display: flex;">


                                    <div class="view-toggler">

                                        <img id="list-view-icon" 
                                        data-original-title="List View"
                                        data-tooltip-translationkey="toggleViewList"
                                        data-tooltip-translation-default="List View">

                                        <img id="thumbnail-icon" 
                                        data-original-title="Thumb View"
                                        data-tooltip-translationkey="toggleViewThumb"
                                        data-tooltip-translation-default="Thumb View">
                                    </div>

                                    <div style="display:none" class="toggle-switch-container">
                                        <div class="toggle-switch switch-vertical">
                                          <input id="toggle-saved-cart" class="no-uniform" type="radio" name="toggle-cart-switch" value="1" checked="checked" />
                                          <label for="toggle-saved-cart"></label>
                                          <input id="toggle-current-cart" class="no-uniform" type="radio" name="toggle-cart-switch" value="2" />
                                          <label data-translation-key="currentCartOption" data-translation-default="Current Cart" for="toggle-current-cart">Current Cart</label>
                                          <span class="toggle-outside">
                                            <span class="toggle-inside"></span>
                                          </span>
                                        </div>
                                      </div>

                                    <a class="btn btn-circle btn-icon-only btn-default fullscreen"
                                       href="javascript:;">
                                        <img class="zoomin-icon"
                                        data-original-title="Full Screen" 
                                       data-tooltip-translationkey="fullscreen"
                                       data-tooltip-translation-default="Full Screen">

                                        <img class="zoomout-icon"
                                        data-original-title="Minimise"
                                        data-tooltip-translationkey="minimise"
                                        data-tooltip-translation-default="Minimise">
                                    </a>

                                </div>
                            </div>
                            <div class="portlet-body">
                                <div id="breadcrumbsbuttonhide" class="breadcrumbsBackButton">

                                    <a type="button" onclick="goBack(); return false;">
                                        <img class="backButtonIcon" src="img/default/back_icon.svg" width="20px" height="20px">
                                        <span style="font-weight: 600; font-size: 14px; margin-left: 4px;"
                                              data-translation-key="back" data-translation-default="Back">Back</span>
                                    </a>
                                </div>
                                <div class="row" id="salestoolkit-favourites"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END PAGE CONTENT-->
        </div>
    </div>
    
    <div class="notific8-container top left" style="z-index: 1100;"></div>
    <!-- END CONTAINER -->
    `;

    /**
     * Handles the back button functionality for the favourites module.
     */
    function _goBack() {
        // Use the global loadContent function to navigate back to the index page
        const newUrl = 'index.html?loadCB=1&favBackButton=true';
        window.history.replaceState({ path: newUrl }, '', newUrl);
        loadContent('index');
        return false;
    }

    /**
     * Updates the cart and favourites icons for a specific item.
     * @param {object} item - The item object (asset or collection).
     * @returns {boolean} - Always returns false to prevent default link behavior.
     */
    function _updateItemCartAndFavouritesTagsAndReturnFalse(item) {
        const itemElement = document.querySelector('.atheneum-item[data-atheneum-item-id="' + item.id + '"]');
        if (!itemElement) return false;

        const cartButton = itemElement.querySelector('[data-atheneum-item-action="toggle-cart"]');
        const cartImage = cartButton ? cartButton.querySelector("img") : null;

        const itemInCart = SalesToolkit.Cart.assetIds.includes(item.id);

        if (itemInCart) {
            if (cartButton) {
                cartButton.classList.add("already-clicked");
                cartButton.setAttribute("title", SalesToolkit.Translation.get('cartToggleRemove', 'Remove from Cart'));
            }
            if (cartImage) {
                cartImage.setAttribute("src", SHOPPING_CART_FULL);
            }
        } else {
            if (cartButton) {
                cartButton.classList.remove("already-clicked");
                cartButton.setAttribute("title", SalesToolkit.Translation.get('cartToggleAdd', 'Add to Cart'));
            }
            if (cartImage) {
                cartImage.setAttribute("src", SHOPPING_CART_EMPTY);
            }
        }
        return false;
    }

    /**
     * Initializes the Favourites module.
     */
    function _init() {
        console.log('Initializing favouritesModule...');

         window.updateItemCartAndFavouritesTagsAndReturnFalse = _updateItemCartAndFavouritesTagsAndReturnFalse;
         
        // Initialize icon path variables
        SHOPPING_CART_EMPTY = SalesToolkit.Theme.getStringProperty('salestoolkitAssetTileIconCart', 'img/default/shopping_cart_new_blue.svg');
        SHOPPING_CART_FULL = SalesToolkit.Theme.getStringProperty('salestoolkitAssetTileIconCartFilled', 'img/default/shopping_cart_full_new.svg');
        REMOVE_ICON = SalesToolkit.Theme.getStringProperty('salestoolkitAssetTileIconRemoveFavourite', SalesToolkit.Theme.getStringProperty('salestoolkitAssetTileIconRemove', 'img/default/bin_icon.svg'));

        // Rewrite icon URLs if CrossPlatform is enabled
        if (SalesToolkit.CrossPlatform.enabled) {
            const iconsToRewrite = [
                { key: 'SHOPPING_CART_EMPTY', value: SHOPPING_CART_EMPTY },
                { key: 'SHOPPING_CART_FULL', value: SHOPPING_CART_FULL },
                { key: 'REMOVE_ICON', value: REMOVE_ICON }
            ];
            iconsToRewrite.forEach(icon => {
                if (SalesToolkit.CrossPlatform.urlRewriteCache[icon.value]) {
                    window[icon.key] = SalesToolkit.CrossPlatform.urlRewriteCache[icon.value];
                } else {
                    addUrlToRewriteQueue(icon.value, (rewrittenURL) => {
                        $('img[src="' + icon.value + '"]').attr('src', rewrittenURL);
                        window[icon.key] = rewrittenURL;
                    });
                }
            });
        }
        
        // Override the global goBack function
        if (typeof window.goBack === 'function') {
            _originalGoBack = window.goBack;
        }
        window.goBack = _goBack;

        // Initialize the Favourites UI component
        favouritesViewer = SalesToolkit.UI.Favourites(document.getElementById('salestoolkit-favourites'));

        // Attach event listeners
        favouritesViewer.on('info-requested', (item) => {
            showInformationForItem(item);
        });

        favouritesViewer.on('item-added', (item) => {
            const itemElement = document.querySelector('#salestoolkit-favourites .atheneum-item[data-atheneum-item-id="' + item.id + '"]');
            if (!itemElement) return;

            const thumbnailElement = itemElement.querySelector('.thumbnail');
            if (thumbnailElement) {
                const bgImageURL = thumbnailElement.getAttribute('data-background-image-url');
                if (bgImageURL) {
                    addUrlToRewriteQueue(bgImageURL, (rewrittenURL) => {
                        if (rewrittenURL && rewrittenURL.includes("https:") && !rewrittenURL.includes("keepRatio=true&shouldCrop=false&width=800&height=450")) {
                            rewrittenURL += "?keepRatio=true&shouldCrop=false&width=800&height=450";
                        }
                        thumbnailElement.style.backgroundImage = `url('${rewrittenURL}')`;
                        thumbnailElement.style.opacity = 1;
                    });
                }
            }
            
            const infoIconElement = itemElement.querySelector('.atheneum-item .asset-style .info-btn img');
            if(infoIconElement){
                if(SalesToolkit.Theme.getBooleanProperty('hideAssetInformationButton', false))
                    infoIconElement.style.display = 'none';
                else{
                    applyImageToElement(infoIconElement, 'assetInformationIcon', 'img/default/info_icon.svg')
                    infoIconElement.style.display = 'block';
                }
            }

            const removeIcon = itemElement.querySelector('.remove-icon');
            if (removeIcon) removeIcon.src = REMOVE_ICON;

             favouritesViewer.trigger("item-update-cart-button", item);
        });

        favouritesViewer.on('refresh', () => {
            $("body > .tooltip").remove();
        });

        favouritesViewer.on('item-removed-from-favourites', () => {
            $("body > .tooltip").remove();
        });

        favouritesViewer.on("item-added-to-cart", (item) => {
            SalesToolkit.UI.Cart.updateMenuCartBadge();
            favouritesViewer.trigger("item-update-cart-button", item);
        });

        favouritesViewer.on("item-removed-from-cart", (item) => {
            SalesToolkit.UI.Cart.updateMenuCartBadge();
            favouritesViewer.trigger("item-update-cart-button", item);
            const cartButtonImg = document.querySelector(`[data-atheneum-item-id="${item.id}"] [data-atheneum-item-action="toggle-cart"] img`);
            if (cartButtonImg) $(cartButtonImg).attr("src", SHOPPING_CART_EMPTY);
        });

        favouritesViewer.on("item-update-cart-button", _updateItemCartAndFavouritesTagsAndReturnFalse);

        favouritesViewer.on("item-action-view-click", (item) => {
            if(item.type === "asset" && !SalesToolkit.Library.assets[item.id].canPreview) return false;

            if (item.type === "asset" && SalesToolkit.Pages.PreviewAssetPage.url) {
                loadAssetScreen(item.id, "?from=favourites");
            } else if (item.type === "collection" && SalesToolkit.Pages.ExploreCollectionPage.url) {
                loadIndexScreen(false, false, item.id, false);
            }
            return false;
        });

        favouritesViewer.on("item-action-failure", (item, action, details) => {
            if (action === "add-to-cart" && Atheneum.Callbacks.isOffline(details.reason, details.httpStatus, details.errorCode)) {
                const notificationBody = SalesToolkit.Translation.getFormatted('notificationCartAdded', 'Added {0} to Cart', [item.name]);
                SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                favouritesViewer.trigger("item-update-cart-button", item);
            }
            if (action === "remove-from-cart" && Atheneum.Callbacks.isOffline(details.reason, details.httpStatus, details.errorCode)) {
                const notificationBody = SalesToolkit.Translation.getFormatted('notificationCartRemoved', 'Removed {0} from Cart', [item.name]);
                SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                favouritesViewer.trigger("item-update-cart-button", item);
            }
            if (action === "remove-from-favourites" && Atheneum.Callbacks.isOffline(details.reason, details.httpStatus, details.errorCode)) {
                const notificationBody = SalesToolkit.Translation.getFormatted('notificationFavouritesRemoved', 'Removed {0} from Favourites', [item.name]);
                SalesToolkit.UI.Notifications.showCustomNotification("favourites", notificationBody);
                favouritesViewer.removeItem(item);
            }
            favouritesViewer.refresh();
        });

        favouritesViewer.on("item-action-click", (item, action) => {
            const button = document.querySelector(`[data-atheneum-item-id="${item.id}"] [data-atheneum-item-action="${action}"]`);
            if (button) button.blur();
        });

        // Update library and then favourites
        SalesToolkit.Library.update({
            success: () => {
                SalesToolkit.Favourites.update({
                    success: () => favouritesViewer.refresh(),
                    failure: Atheneum.Callbacks.logFailureDetails
                });
            },
            failure: (reason, httpStatus, errorCode) => {
                if (reason === Atheneum.API.Problems.CONNECTION_FAILED) {
                    // Handle offline mode if necessary
                }
                Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode);
            }
        });

        favouritesViewer.refresh();
        SalesToolkit.NewsFeed.checkForReplies();
    }

    /**
     * Destroys the Favourites module.
     */
    function _destroy() {
        console.log('Destroying favouritesModule...');
        
        // Destroy the favouritesViewer instance and remove its event listeners
        if (favouritesViewer && typeof favouritesViewer.destroy === 'function') {
            favouritesViewer.destroy();
        }
        favouritesViewer = null;

        delete window.updateItemCartAndFavouritesTagsAndReturnFalse;

        // Restore the original goBack function
        if (_originalGoBack) {
            window.goBack = _originalGoBack;
            _originalGoBack = null;
        } else {
            delete window.goBack;
        }

        // Clean up any other event listeners specific to this module
        $("a.fullscreen").off("click");
    }

    // Expose the public methods and properties
    return {
        init: _init,
        destroy: _destroy,
        templateHTML: _templateHTML
    };

})();
